import {
  Button,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { colorBackgroundLayoutMain } from '@cloudscape-design/design-tokens';
import { OrderTypes } from '@parallel-fluidics/shared/constants';
import { formatDate } from '@parallel-fluidics/shared/shipping';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import ActiveOrderStatus from '../../components/ActiveOrders';
import useCustomInfiniteQuery from '../../hooks/use-customInfiniteQuery';
import useOrderFilter from '../../hooks/use-orderFilter';

function ShippedOrdersPage() {
  const navigate = useNavigate();
  const { orderType, FilterButtons } = useOrderFilter();

  const queryParams = useMemo(() => [
    collection(getFirestore(), 'orders'),
    where('hasShippedItems', '==', true),
    ...(orderType ? [where('isInternal', '==', orderType === OrderTypes.INTERNAL)] : []),
    orderBy('orderDate', 'desc'),
  ], [orderType]);

  const { CustomPagination, pageData } = useCustomInfiniteQuery({ queryKey: 'getShippedOrders', queryParams, pageSize: 10 });

  const shippedOrders = useMemo(() => {
    const projects = [];
    (pageData || []).forEach((order) => {
      (order?.shipments || []).forEach((shipment) => {
        if (!shipment.isShipped) return;
        (shipment?.lineItems || []).forEach((lineItem) => {
          if (lineItem.steps[0]?.goal > 0) {
            const lastTrackingData = shipment.trackingData?.[shipment.trackingData.length - 1];
            const trackShipDate = lastTrackingData?.shipDate
              ? formatDate(lastTrackingData.shipDate)
              : null;

            projects.push({
              lineItemId: lineItem.id,
              organization: order.organization,
              projectNumber: `${lineItem.projectId}${lineItem.pPartId ? `-${lineItem.pPartId}` : ''}`,
              projectId: lineItem.projectId,
              projectDocId: lineItem.projectDocId,
              shipDate: shipment.targetShipDate,
              shipDateActual: shipment.shipDate || trackShipDate,
              steps: lineItem.steps,
              notes: lineItem.notes,
            });
          }
        });
      });
    });
    projects.sort((a, b) => new Date(b.shipDate).getTime() - new Date(a.shipDate).getTime());
    return projects;
  }, [pageData]);

  return (
    <div>
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 5,
        background: colorBackgroundLayoutMain,
        paddingBottom: 16,
      }}
      >
        <Header
          actions={<Button variant="normal" onClick={() => { navigate('/orders/active'); }}>See active orders</Button>}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div>Past Orders</div>
            <FilterButtons />
          </div>
        </Header>
        <div style={{ display: 'flex', justifyContent: 'end', paddingTop: 8 }}>
          <CustomPagination />
        </div>
      </div>
      <SpaceBetween direction="vertical" size="l">
        {shippedOrders.map((order) => (
          <ActiveOrderStatus
            key={order.lineItemId || order.projectNumber}
            lineItemId={order.lineItemId || order.projectNumber}
            organization={order.organization}
            projectNumber={order.projectNumber}
            projectId={order.projectId}
            projectDocId={order.projectDocId}
            shipDate={order.shipDate}
            shipDateActual={order.shipDateActual}
            steps={order.steps}
            notes={order.notes}
          />
        ))}
      </SpaceBetween>
    </div>
  );
}

export default ShippedOrdersPage;
